import { wsService } from "./wsService";
import UserTypeConstant from "@/constants/user_type";

const section = "reports";
const user_type = localStorage.getItem("user_type");

function ingresos(param = { enable: true }) {


  return wsService.make_post_request(section + "/ingresos", param);
}

function egresos(param = { enable: true }) {


  return wsService.make_post_request(section + "/egresos", param);
}

function egresosDetalle(param = { enable: true }) {

  return wsService.make_post_request(section + "/egresos-detalle", param);
}

function ingresosDetalle(param = { enable: true }) {


  return wsService.make_post_request(section + "/ingresos-detalle", param);
}

function ocupacion(param = { enable: true }) {


  param["group_by"] = "pallet";
  return wsService.make_post_request(section + "/ocupacion", param);
}

function stock_products(param = { enable: true }) {


  param["group_by"] = "product";
  return wsService.make_post_request(section + "/stock-products", param);
}

function movimientos_stock(param = { enable: true }) {


  param["group_by"] = "product";
  return wsService.make_post_request(section + "/movimientos-stock", param);
}

function productividad(param = { enable: true }) {
  return wsService.make_post_request(section + "/productividad", param);
}

function productividad_operario(param = { enable: true }) {
  return wsService.make_post_request(section + "/productividad-operario", param);
}

export const reportsService = {
  section,
  ingresos,
  egresos,
  ingresosDetalle,
  egresosDetalle,
  ocupacion,
  stock_products,
  movimientos_stock,
  productividad,
  productividad_operario,
};
